module.exports = __webpack_public_path__ + "static/img/49-3.6700fa8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/49-3.jpg
// module id = mend
// module chunks = 0